import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title:
    "Controla får stöd från MSB för att stärka Sveriges digitala motståndskraft",
  header:
    "Controla får stöd från MSB för att stärka Sveriges digitala motståndskraft",
  date: "2025-10-16",
  description:
    "Controla får finansiering från MSB och NCC‑SE för att hjälpa organisationer att se sina kritiska system, beroenden och cyberrisker i den digitala leverantörskedjan.",
  category: "företag",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
